// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Configuración Firebase
const firebaseConfig = {
  apiKey: "AIzaSyB-f1DkrXiwztuP_cKniLyR6X4YDlkuOpc",
  authDomain: "mvexpress-34212.firebaseapp.com",
  projectId: "mvexpress-34212",
  storageBucket: "mvexpress-34212.firebasestorage.app",
  messagingSenderId: "78246970929",
  appId: "1:78246970929:web:5201bd50a4a2740a9ff710",
  measurementId: "G-C903Q0141F"
};

const app = initializeApp(firebaseConfig);
let messaging;
if (typeof window !== 'undefined') messaging = getMessaging(app);

export async function requestWebPushPermission() {
  if (!messaging) return;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Permisos web denegados');

  const token = await getToken(messaging, { 
    vapidKey: 'BKRniEGqVdhR2TxIDgA9xuYqJWuxs31hptHmm8Cgj0oMRKD6hW7igPWVY6ZhKV7OG0ZEk_hrWPSRcIr4GfYt-JA'
  });

  console.log('Token FCM web:', token);

  onMessage(messaging, (payload) => {
    console.log('Notificación web recibida:', payload);
    alert(payload.notification?.body || 'Hola Mundo web!');
  });

  return token;
}

export { app, messaging };
